var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.874,
    height: 92.875,
    viewBox: "0 0 92.874 92.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_102",
    x: 0,
    y: 0,
    width: 92.874,
    height: 92.875,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_261_1",
    "data-name": "Component 261 \\u2013 1",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    d: "M76.374,38.937A37.437,37.437,0,1,1,38.937,1.5,37.437,37.437,0,0,1,76.374,38.937",
    transform: "translate(7.5 4.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1816.657,1085.129a12.984,12.984,0,0,0-18.411,5.01c-.428.806-.863,1.624-1.547,2.909-.683-1.286-1.12-2.1-1.546-2.909a12.986,12.986,0,0,0-18.413-5.01c-6.586,4.182-8.458,13.085-3.362,18.886,7.459,8.492,15.411,16.55,23.321,24.973,7.91-8.422,15.862-16.481,23.32-24.973C1825.115,1098.214,1823.244,1089.312,1816.657,1085.129Z",
    transform: "translate(-1759.314 -1065.713)",
    fill: "#ff69b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.8d47afb76fd24e4ae473fa86c9e29808.svg";
export { ForwardRef as ReactComponent };